import gql from "graphql-tag";

export const GET_PHOTO_SUBMISSIONS_COUNTS = gql`
    query getPhotoSubmissionsCounts {
        pending: listPhotoUploads(status: SUBMITTED) {
            totalCount
        }

        autoDenied: listPhotoUploads(status: AUTOMATICALLY_DENIED) {
            totalCount
        }

        manuallyDenied: listPhotoUploads(status: MANUALLY_DENIED) {
            totalCount
        }
    }
`;

export const GET_CREATORS_TOTAL_PHOTO_COUNT = gql`
    query browsePhotosByCreator($creator: String!) {
        browsePhotosByCreator(creator: $creator) {
            totalCount
        }
    }
`;
